const studentPageStrings = {
  en: {
    navbar: {
      appName: "TA Connect",
      login: "Login",
      register: "Register",
    },

    studentHomePage: {
      title: "Student Dashboard",
      description:
        "Welcome to TA Connect! Use the sidebar to navigate and book office hours with your TAs, or manage your existing bookings.",
      bookSlot: "Book a Slot",
      bookSlotDescription: "Browse available office hours and schedule time with your TAs",
      viewBookings: "View My Bookings",
      viewBookingsDescription: "View, update, or cancel your scheduled appointments",
      quickTips: {
        title: "Quick Tips",
        tip1: "• Book office hours at least 24 hours in advance when possible",
        tip2: "• Check your email for booking confirmations",
        tip3: "• Cancel appointments you can't make to free up slots for others",
      },
    },
  },
  ar: {
    navbar: {
      appName: "TA Connect",
      login: "تسجيل الدخول",
      register: "إنشاء حساب",
    },

    studentHomePage: {
      title: "لوحة الطالب",
      description:
        "مرحباً بك في TA Connect! استخدم القائمة الجانبية للتنقل وحجز المواعيد مع المعيدين، أو لإدارة حجوزاتك الحالية.",
      bookSlot: "احجز موعداً",
      bookSlotDescription: "تصفح المواعيد المتاحة واحجز موعدك مع المعيدين",
      viewBookings: "حجوزاتي",
      viewBookingsDescription: "اعرض، عدّل، أو ألغِ مواعيدك المحجوزة",
      quickTips: {
        title: "نصائح مفيدة",
        tip1: "• احجز موعدك قبل 24 ساعة على الأقل من الوقت المطلوب",
        tip2: "• تحقق من بريدك الإلكتروني لاستلام تأكيد الحجز",
        tip3: "• ألغِ المواعيد التي لا تستطيع حضورها لإتاحتها للطلاب الآخرين",
      },
    },
  },
};

export default studentPageStrings;
